import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=c91ef6ce&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91ef6ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c91ef6ce')) {
      api.createRecord('c91ef6ce', component.options)
    } else {
      api.reload('c91ef6ce', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=c91ef6ce&scoped=true", function () {
      api.rerender('c91ef6ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/one-part-a/Main.vue"
export default component.exports